// extracted by mini-css-extract-plugin
module.exports = {"maxWidth":"styles_maxWidth__rF_rr"};